import React, { useState } from 'react';

import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { ServerRequest } from '../../utils/apiweb';
import { getDateToString  } from '../../utils/convert';
import { TableCustom, SectionHeading, InputLista, AdvancedSearch, InputWithEnterEvent } from '../../components/common';
import ExpedienteModal from '../../components/controls/ExpedienteModal';
import DataTaggerModalApi from '../../components/controls/DataTaggerModalApi';
import { useManagedContext } from '../../components/hooks';
import { MESSAGE_MODALS } from '../../context/custom/MessageModalContext';
import {usePermissions} from "../../components/hooks/usePermissions";
import {PERMISSIONS} from "../../consts/permissions";
import { TIPS } from '../../consts/tips';

function ExpedientesView() {

    //hooks
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [state, setState] = useState({
        showForm: false,
        modeFormEdit: false,
        rowId: 0,
        dataTagger: {
            showModal: false,
            idEntidad: null
        },
        list: []
    });

    const [filters, setFilters] = useState({
        labels: [
            { title: 'Tipo expediente', field: 'descTipoExpediente', value: '', valueIgnore: '', fieldOriginal: 'idTipoExpediente', valueIgnoreOriginal: 0},
            { title: 'Expediente', field: 'expediente', value: '', valueIgnore: '' },
            { title: 'Etiqueta', field: 'etiqueta', value: '', valueIgnore: '' }
        ]
    });

    const [tableVisible, setTableVisible] = useState(false)

    const [ formValues, formHandle, , formSet ] = useForm({
        idTipoExpediente: 0,
        descTipoExpediente: '', //no existe como control, se usa para tomar el text del tipo
        expediente: '',
        etiqueta: ''
    });

    const { hasPermission } = usePermissions();
    const canEdit = hasPermission(PERMISSIONS.EXPEDIENTE_EDIT);

    //definiciones
    const buildExpedienteCell = (row) => `${row.ejercicio}-${row.numero}-${row.letra}`
    const tableColumns = [
        { Header: 'Expediente', Cell: ({ row }) => buildExpedienteCell(row.original), id: 'expediente', accessor: 'numero', width: '70%' },
        { Header: 'Fecha de creación', Cell: (data) => (data.value) ? getDateToString(data.value, false) : '', accessor: 'fechaCreacion', width: '20%' },
    ];

    //handles
    const avmr = {
        onAdd: () => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: 0}))
        },
        onView: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: false, rowId: parseInt(id)}))
        },
        onModify: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: parseInt(id)}))
        },
        onRemove: ({ id }) => {
            const expediente = state.list.find(x => x.id === id)
            showMessageModal({
                ...MESSAGE_MODALS.BORRAR,
                message: `¿Está seguro de borrar el expediente ${buildExpedienteCell(expediente)}?`,
                onConfirm: () => RemoveExpediente(id),
            })
        },
        onAdditionalInfo: ({ id }, disabled) => {
            setState(prevState => ({...prevState, dataTagger: {showModal: true, idEntidad: id, disabled}}))
        },
    }


    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setIsLoading(false)
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setIsLoading(false)
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setIsLoading(false)
    }

    //funciones
    function SearchExpedientes() {

        setIsLoading(true)
        setState(prevState => {
            return {...prevState, list: []};
        });

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                data.forEach(x => {
                    if (x.fechaCreacion) x.fechaCreacion = new Date(x.fechaCreacion);
                });
                setIsLoading(false)
                setTableVisible(true)
                setState(prevState => {
                    return {...prevState,list: data};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };

        const paramsUrl = `/filter?`+
        `idTipoExpediente=${formValues.idTipoExpediente}&`+
        `expediente=${encodeURIComponent(formValues.expediente)}&`+
        `etiqueta=${encodeURIComponent(formValues.etiqueta)}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EXPEDIENTE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function RemoveExpediente(id) {

        setIsLoading(true)

        const callbackSuccess = (response) => {
            response.json()
            .then((id) => {
                setIsLoading(false)
                SearchExpedientes();
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };

        const paramsUrl = `/${id}`;

        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.EXPEDIENTE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }


    function ApplyFilters() {
        UpdateFilters();
        SearchExpedientes();
    }
    function UpdateFilters() {
        let labels = [...filters.labels];
        labels.forEach((label) => {
            label.value = formValues[label.field];
        });
        setFilters(prevState => {
            return {...prevState, labels: labels};
        });
    }

    const dataTaggerRow = state.list.find(x => x.id === state.dataTagger.idEntidad)
    const dataTaggerRegistro = dataTaggerRow ? `el expediente ${buildExpedienteCell(dataTaggerRow)}` : ''

    return (
    <>

        {state.dataTagger.showModal &&
            <DataTaggerModalApi
                title="Información adicional de expediente"
                registro={dataTaggerRegistro}
                entidad="Expediente"
                idEntidad={state.dataTagger.idEntidad}
                disabled={state.dataTagger.disabled}
                tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_EXPEDIENTE_MODAL}
                onConfirm={() => {
                    setState(prevState => {
                        return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
                    });
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
                    });
                }}
            />
        }

        {state.showForm && 
            <ExpedienteModal
                id={state.rowId}
                disabled={!state.modeFormEdit}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false};
                    });
                }}
                onConfirm={(id) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowId: 0};
                    });
                    if (tableVisible) SearchExpedientes();
                }}
            />
        }

        <SectionHeading titles={['Expedientes']} title={<>Expedientes</>}
                        onAddClick={canEdit ? avmr.onAdd : null} tableVisible={tableVisible} />

        <section className='section-accordion'>

            <AdvancedSearch
                formValues={formValues}
                formSet={formSet}
                labels={filters.labels.filter(f => f.value !== f.valueIgnore)}
                onSearch={ApplyFilters}
            >

                <div className='row form-basic'>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="idPersona" className="form-label">Tipo expediente</label>
                        <InputLista
                            name="idTipoExpediente"
                            placeholder=""
                            textItemZero="Todos"
                            className="form-control"
                            value={ formValues.idTipoExpediente }
                            onChange={({target}) =>{
                                let idTipoExpediente = 0;
                                let descTipoExpediente = '';
                                if (target.row) {
                                    idTipoExpediente = parseInt(target.value);
                                    descTipoExpediente = target.row.nombre;
                                }
                                formSet({...formValues, idTipoExpediente: idTipoExpediente, descTipoExpediente: descTipoExpediente});
                            }}
                            lista="TipoExpediente"
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="expediente" className="form-label">Expediente</label>
                        <InputWithEnterEvent
                            name="expediente"
                            type="text"
                            placeholder=""
                            className="form-control"
                            value={ formValues.expediente }
                            onChange={ formHandle }
                            onEnter={ApplyFilters}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="etiqueta" className="form-label">Etiqueta</label>
                        <InputWithEnterEvent
                            name="etiqueta"
                            type="text"
                            placeholder=""
                            className="form-control"
                            value={ formValues.etiqueta }
                            onChange={ formHandle }
                            onEnter={ApplyFilters}
                        />
                    </div>
                </div>

            </AdvancedSearch>

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    columns={tableColumns}
                    data={state.list}
                    avmr={avmr}
                    editCode={PERMISSIONS.EXPEDIENTE_EDIT}
                    messageEmpty="No se encontraron resultados"
                />
            )}

        </section>
        
        {window.location.pathname.split('/')[2] === 'nh' && (
            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <button className="btn back-button float-start" onClick={window.close}>Salir</button>
                </div>
            </footer>
        )}
    </>
    )
}

export default ExpedientesView;
